module.exports = __webpack_public_path__ + "static/mevia-footerBanner-min-640760dfaeab6764515584d2ab5ddab3.jpg";